import React from "react";
import Button from "components/Button";
import Label from "components/Label";
import { useHistory } from "react-router-dom";

type Props = {
  title: string;
  subTitle: string;
  titleButton: string;
  action: string;
  role?: string;
};

const ContactAuth: React.FC<Props> = ({
  title,
  subTitle,
  titleButton,
  action,
  role,
}): JSX.Element => {
  let history = useHistory();

  return (
    <div
      className="mt-24"
      style={{
        width: "449px",
        background: "#FFFFFF",
        border: "1px solid #000000",
        borderRadius: "14px",
      }}
    >
      <div className="flex flex-col mx-auto justify-center h-52 rounded-md">
        <Label
          label={title}
          className="mt-6 flex flex-row justify-center font-nunito font-light text-2xl text-purple"
        />

        <div className="my-6 flex flex-row justify-center">
          <Label
            label={subTitle}
            className="mx-12 font-nunito font-light text-xs"
            style={{ color: "#ADAEB3" }}
          />
        </div>

        <div className="flex flex-row justify-center">
          <Button
            label={titleButton}
            className="font-sora font-light text-sm text-black border border-1 border-black w-72 h-8 rounded-lg"
            onClick={() => {
              if (role) {
                history.push(action, { role });
              } else {
                history.push(action);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ContactAuth;
